import { makeStyles, mergeClasses, tokens } from "@fluentui/react-components";
import { NotificationsPanel } from "../../../components-v2/notifications/side-bar";

const AppSidebar = () => {
  const styles = useStyles();

  return (
    <aside
      className={mergeClasses("amd-right-panel", styles.container)}
      data-testid="app-sidebar"
    >
      <NotificationsPanel />
    </aside>
  );
};

export default AppSidebar;

const useStyles = makeStyles({
  container: {
    backgroundColor: tokens.colorNeutralBackground1,
    borderRadius: "8px",
    boxShadow: "var(--shadow8)",
  },
});
